import React, { useState } from 'react';
import axios from 'axios';
import { Alert, Box, Button, Link, Stack, Typography } from '@mui/material';
import Input from '../../../components/Input';
import InputPassword from '../../../components/Input/inputPassword';
import logoWhite from '../../../assets/images/logo-white.png';
import '../index.scss';

const LoginForm = () => {
  const [form, setForm] = useState({ email: '', password: '', error: false });

  const handleLogin = event => {
    event.preventDefault();
    axios.post(process.env.REACT_APP_API_URL + 'api/authentication', form).then(
      response => {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('locale', 'pt-BR');
        window.location.href = '/home';
      },
      () => setForm(prev => ({ ...prev, error: true }))
    );
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      width: '100%',
      background: 'linear-gradient(160deg, #006494 0%, #004a6e 55%, #002f46 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
    }}>
      {/* Logo + título acima do card */}
      <Box sx={{ mb: '28px', textAlign: 'center' }}>
        <img src={logoWhite} alt="HWater" style={{ height: '40px', width: 'auto' }} />
        <Typography sx={{ mt: '10px', fontSize: '13px', fontWeight: 600, color: 'rgba(255,255,255,0.75)', textTransform: 'uppercase', letterSpacing: '0.12em' }}>
          Biblioteca Virtual
        </Typography>
      </Box>

      {/* Card de login */}
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          width: '100%',
          maxWidth: '400px',
          backgroundColor: 'rgba(255,255,255,0.97)',
          borderRadius: '16px',
          padding: '40px 36px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
          display: 'flex',
          flexDirection: 'column',
          gap: '0',
          '@media (max-width: 480px)': { padding: '32px 24px', borderRadius: '12px' },
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: '22px', color: '#1c1b1f', mb: '4px' }}>
          Entrar
        </Typography>
        <Typography sx={{ fontSize: '13px', color: '#72787e', mb: '24px' }}>
          Acesse o repositório privado de saneamento
        </Typography>

        <Box sx={{ mb: '12px' }}>
          <Input
            type="email"
            id="email"
            label="Email"
            name="email"
            value={form.email}
            onChange={e => setForm(prev => ({ ...prev, email: e.target.value }))}
          />
        </Box>
        <Box sx={{ mb: '4px' }}>
          <InputPassword
            name="password"
            label="Senha"
            id="password"
            value={form.password}
            onChange={e => setForm(prev => ({ ...prev, password: e.target.value }))}
          />
        </Box>

        {form.error && (
          <Stack sx={{ width: '100%', mt: '8px' }}>
            <Alert severity="error">Email ou senha inválidos!</Alert>
          </Stack>
        )}

        <Button
          type="submit"
          variant="contained"
          className="auth-btn"
          onClick={handleLogin}
          sx={{ mt: '16px' }}
        >
          Entrar
        </Button>

        <Box className="auth-links" sx={{ mt: '16px' }}>
          <Link href="/send_token_password">Esqueci minha senha</Link>
          <span>Não tem conta? <Link href="/register">Cadastre-se</Link></span>
        </Box>
      </Box>

      {/* Tagline abaixo */}
      <Typography sx={{ mt: '28px', fontSize: '12px', color: 'rgba(255,255,255,0.45)', textAlign: 'center' }}>
        Biblioteca Virtual de Saneamento · HWater
      </Typography>
    </Box>
  );
};

export default LoginForm;
